import { Navigate } from "react-router-dom";
import ConfigsSearcher from "../../../config/Configs";

/**
 * Protege una ruta segun el tipo de feature flag:
 * - optIn=true  => el feature es opt-in: ausente/false = bloqueado, "true" = permitido
 * - optIn=false => el feature es opt-out: ausente/true = permitido, "false" = bloqueado
 */
const FeatureGuard = ({ featureKey, optIn = false, redirectTo = "/main/agencias", children }) => {
  const { isFeatureEnabled, isFeatureEnabledOptIn } = ConfigsSearcher();
  const allowed = optIn
    ? isFeatureEnabledOptIn(featureKey)
    : isFeatureEnabled(featureKey);

  return allowed ? children : <Navigate to={redirectTo} replace />;
};

export default FeatureGuard;
